import { render, staticRenderFns } from "./ComentarioIcon.vue?vue&type=template&id=1a332892&scoped=true&"
var script = {}
import style0 from "./ComentarioIcon.vue?vue&type=style&index=0&id=1a332892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a332892",
  null
  
)

export default component.exports